import React, {useEffect, useState} from 'react'
import {useScroll} from './useScroll'

export function useHideForScroll(ref: React.RefObject<HTMLDivElement> | HTMLDivElement | null, paddingTop: number = 60): boolean {
  const scroll = useScroll(ref)
  const [lastScroll, setLastScroll] = useState(scroll)
  const [isShow, setIsShow] = useState(true)

  useEffect(() => {
    const htmlElement = ref instanceof HTMLDivElement ? ref : ref?.current
    if (!htmlElement) return

    setLastScroll(scroll)

    if (scroll <= paddingTop) return setIsShow(true)

    if (htmlElement.offsetHeight + scroll + 200 > htmlElement.scrollHeight) return setIsShow(false)

    setIsShow(lastScroll > scroll)
  }, [scroll, ref])

  return isShow
}